module.exports = __webpack_public_path__ + "static/thumb-9683916f9a0ecaca1f8ba3297a6131f1.png";